import ModelUtil from '@leverege/model-util';
import DetailListModel from "../shared/DetailListModel.js";
const TYPE = 'detail.ItemType';

// This holds the information specific to a rollover type.
// In particular, overrides for the placement on screen and
// at cursor. This contains a detail list

function create(objectType, extra) {
  return {
    type: TYPE,
    objectType: objectType || null,
    display: null,
    // null or block/inline/etc. Null means no override
    details: DetailListModel.create({
      variant: 'item',
      ...extra
    })
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('display'),
  ...ModelUtil.createAllValue('details')
};